import { render, staticRenderFns } from "./Speak.vue?vue&type=template&id=04290bfa&scoped=true&"
import script from "./Speak.vue?vue&type=script&lang=ts&"
export * from "./Speak.vue?vue&type=script&lang=ts&"
import style0 from "./Speak.vue?vue&type=style&index=0&id=04290bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04290bfa",
  null
  
)

export default component.exports